import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tf-tfmat-lib',
  template: `
    <p>
      tfmat-lib works!
    </p>
  `,
  styles: []
})
export class TfmatLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
